import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@m43/core';
import { BoloResource } from '@mark43/cad-api';

export const useBoloPanelLog = (boloId: number) => {
    const apiClient = useApiClient();

    const eventLogQuery = useQuery({
        queryKey: ['bolo-panel-log', boloId],
        queryFn: () => {
            return apiClient.request<BoloResource.GetBoloLog>({
                url: 'bolo/log',
                method: 'POST',
                data: {
                    boloId,
                },
            });
        },
    });

    return {
        isLoading: eventLogQuery.isLoading,
        boloLog: eventLogQuery.data,
    };
};
